const RegionSelectPageReducer = (state, action) => {
  switch (action.type) {
    case 'REGIONS_FETCHING':
      return {...state, regions: {...state.regions, isFetching: true}};
    case 'REGIONS_UPDATE':
      return {...state, regions: {...state.regions, isFetching: false, items: action.data}};
    case 'DISTRICTS_FETCHING':
      return {
        ...state,
        districts: {
          ...state.districts,
          [action.data.key]: {isFetching: true, items: [], error: null},
        },
      };
    case 'DISTRICTS_UPDATE':
      return {
        ...state,
        districts: {
          ...state.districts,
          [action.data.key]: {
            isFetching: false,
            items: action.data.items,
            error: null,
          },
        },
      };
    default:
      return state;
  }
};

export {RegionSelectPageReducer};
